import types from './types';

const manualRehydrateFilter = (filter) => ({
  type: types.MANUAL_REHYDRATE_FILTER,
  payload: {
    filter
  }
});

const setActiveDrawTool = (activeDrawTool) => ({
  type: types.SET_ACTIVE_DRAW_TOOL,
  payload: {
    activeDrawTool
  }
});


const setBasicFilterActive = (isBasicFilterActive) => ({
  type: types.SET_BASIC_FILTER_ACTIVE,
  payload: {
    isBasicFilterActive
  }
});
const setFilterGeometry = (geometry) => ({
  type: types.SET_FILTER_GEOMETRY,
  payload: {
    geometry
  }
});

const setSpatialFilterID = (spatialFilterID) => ({
  type: types.SET_SPATIAL_FILTER_ID,
  payload: {
    spatialFilterID
  }
});
const setHasSpatialFilter = (hasSpatialFilter) => ({
  type: types.SET_HAS_SPATIAL_FILTER,
  payload: {
    hasSpatialFilter
  }
});
const setUseExtentFilter = (useExtent) => ({
  type: types.SET_USE_EXTENT_FILTER,
  payload: {
    useExtent
  }
});

//
const setMapDrawingPaused = (paused) => ({
  type: types.SET_MAP_DRAWING_PAUSED,
  payload: {
    paused
  }
});

const setFilterLoading = (loading) => ({
  type: types.SET_FILTER_LOADING,
  payload: {
    loading
  }
});

const setFilterVisible = (visible) => ({
  type: types.SET_FILTER_VISIBLE,
  payload: {
    visible
  }
});

const resetFilters = () => ({
  type: types.RESET_FILTERS,
  payload: {}
});


const addFireCause = (fireCause) => ({
  type: types.ADD_FIRE_CAUSE,
  payload: {
    fireCause
  }
});

const removeFireCause = (fireCause) => ({
  type: types.REMOVE_FIRE_CAUSE,
  payload: {
    fireCause
  }
});

const clearFireCause = () => ({
  type: types.CLEAR_FIRE_CAUSE,
  payload: {}
});

const addInitialStrategy = (strategy) => ({
  type: types.ADD_INITIAL_STRATEGY,
  payload: {
    strategy
  }
});

//SET_PERIMETER_ACREAGE_IDS
/*const setPerimeterAcreageIds = (perimeterAcreageIds) => ({ 
  type: types.SET_PERIMETER_ACREAGE_IDS,
  payload: {
    perimeterAcreageIds
  }
}); */

const clearPerimeterAcreage = () => ({
  type: types.CLEAR_PERIMETER_ACREAGE,
  payload: {}
});

const setPerimeterAcreageLandowner = (perimeterAcreageLandowner) => ({
  type: types.SET_PERIMETER_ACREAGE_LANDOWNER,
  payload: {
    perimeterAcreageLandowner
  }
});

const setPerimeterAcreageOperator = (perimeterAcreageOperator) => ({
  type: types.SET_PERIMETER_ACREAGE_OPERATOR,
  payload: {
    perimeterAcreageOperator
  }
});

const setPerimeterAcreageNumber = (perimeterAcreageNumber) => ({
  type: types.SET_PERIMETER_ACREAGE_NUMBER,
  payload: {
    perimeterAcreageNumber
  }
});

const setNarrativeFilter = (narrativeFilter, narrativeFilterState) => ({
  type: types.SET_NARRATIVE_FILTER,
  payload: {
    narrativeFilter,
    narrativeFilterState
  }
});

const addDataSource = (source) => ({
  type: types.ADD_DATA_SOURCE,
  payload: {
    source
  }
});
//

const setMultiRoot = (multiRootOnly) => ({
  type: types.SET_MULTI_ROOT,
  payload: {
    multiRootOnly
  }
});

const setInImsr = (inImsr) => ({
  type: types.SET_IN_IMSR,
  payload: {
    inImsr
  }
});

const removeDataSource = (source) => ({
  type: types.REMOVE_DATA_SOURCE,
  payload: {
    source
  }
});

const clearDataSources = () => ({
  type: types.CLEAR_DATA_SOURCE,
  payload: {}
});

const removeInitialStrategy = (strategy) => ({
  type: types.REMOVE_INITIAL_STRATEGY,
  payload: {
    strategy
  }
});

const clearInitialStrategy = () => ({
  type: types.CLEAR_INITIAL_STRATEGY,
  payload: {}
});

const removeIrwinRelationship = (irwinRelationship) => ({
  type: types.REMOVE_IRWIN_RELATIONSHIP,
  payload: {
    irwinRelationship
  }
});

const clearIrwinRelationships = () => ({
  type: types.CLEAR_IRWIN_RELATIONSHIPS,
  payload: {}
});

const addIrwinRelationship = (irwinRelationship) => ({
  type: types.ADD_IRWIN_RELATIONSHIP,
  payload: {
    irwinRelationship
  }
});

const addLandownerCategory = (category) => ({
  type: types.ADD_LANDOWNER_CATEGORY,
  payload: {
    category
  }
});

const removeLandownerCategory = (category) => ({
  type: types.REMOVE_LANDOWNER_CATEGORY,
  payload: {
    category
  }
});

const clearLandownerCategory = () => ({
  type: types.CLEAR_LANDOWNER_CATEGORY,
  payload: {}
});


const addInitialType = (category) => ({
  type: types.ADD_INITIAL_TYPE,
  payload: {
    category
  }
});

const removeInitialType = (category) => ({
  type: types.REMOVE_INITIAL_TYPE,
  payload: {
    category
  }
});

const clearInitialType = () => ({
  type: types.CLEAR_INITIAL_TYPE,
  payload: {}
});

const setFireAcreage = (acres) => ({
  type: types.SET_FIRE_ACRE_FILTER,
  payload: {
    acres
  }
});

const clearFireAcreage = () => ({
  type: types.CLEAR_FIRE_ACRE_FILTER,
  payload: {}
});

const setUtcOffsetFilter = (utcOffset) => ({
  type: types.SET_UTC_OFFSET_FILTER,
  payload: {
    utcOffset
  }
});

const clearUtcOffsetFilter = () => ({
  type: types.CLEAR_UTC_OFFSET_FILTER,
  payload: {}
});

const setFireDiscoveryDates = (discoveryDates) => ({
  type: types.SET_FIRE_DISCOVERY_DATES,
  payload: {
    discoveryDates
  }
});

const clearFireDiscoveryDates = () => ({
  type: types.CLEAR_FIRE_DISCOVERY_DATES,
  payload: {}
});

const setFireOutDates = (outDates) => ({
  type: types.SET_FIRE_OUT_DATES,
  payload: {
    outDates
  }
});

const clearFireOutDates = () => ({
  type: types.CLEAR_FIRE_OUT_DATES,
  payload: {}
});

const setModifiedDates = (modifiedDates) => ({
  type: types.SET_MODIFIED_DATES,
  payload: {
    modifiedDates
  }
});

const clearModifiedDates = () => ({
  type: types.CLEAR_MODIFIED_DATES,
  payload: {}
});

const setImsrDates = (imsrDates) => ({
  type: types.SET_IMSR_DATES,
  payload: {
    imsrDates
  }
});

const clearImsrDates = () => ({
  type: types.CLEAR_IMSR_DATES,
  payload: {}
});

const setStructuresFilter = (structuresDestroyed) => ({
  type: types.SET_STRUCTURES_FILTER,
  payload: {
    structuresDestroyed
  }
});


const setPerimeterMapMethod = (perimeterMapMethod) => ({
  type: types.SET_PERIMETER_MAP_METHOD_FILTER,
  payload: {
    perimeterMapMethod
  }
});

const setPerimeterFeatureStatus = (perimeterFeatureStatus) => ({
  type: types.SET_PERIMETER_FEATURE_STATUS_FILTER,
  payload: {
    perimeterFeatureStatus
  }
});

const setPerimeterFeatureAccess = (perimeterFeatureAccess) => ({
  type: types.SET_PERIMETER_FEATURE_ACCESS_FILTER,
  payload: {
    perimeterFeatureAccess
  }
});

const setInjuriesFilter = (injuries) => ({
  type: types.SET_INJURIES_FILTER,
  payload: {
    injuries
  }
});

const setUniquenessFilter = (uniqueness) => ({
  type: types.SET_UNIQUENESS_FILTER,
  payload: {
    uniqueness
  }
});

const setFatalitiesFilter = (fatalities) => ({
  type: types.SET_FATALITIES_FILTER,
  payload: {
    fatalities
  }
});

const setOtherStructuresDestroyedFilter = (otherStructuresDestroyed) => ({
  type: types.SET_OTHER_STRUCTURES_DESTROYED_FILTER,
  payload: {
    otherStructuresDestroyed
  }
});

const setResidencesThreatenedFilter = (residencesThreatened) => ({
  type: types.SET_RESIDENCES_THREATENED_FILTER,
  payload: {
    residencesThreatened
  }
});

const setOtherStructuresThreatenedFilter = (otherStructuresThreatened) => ({
  type: types.SET_OTHER_STRUCTURES_THREATENED_FILTER,
  payload: {
    otherStructuresThreatened
  }
});


const setModifiedBySystemFilter = (modifiedBySystem) => ({
  type: types.SET_MODIFIED_BY_SYSTEM_FILTER,
  payload: {
    modifiedBySystem
  }
});

const setCapabilityRequestsFilter = (capabilityRequests) => ({
  type: types.SET_CAPABILITY_REQUESTS_FILTER,
  payload: {
    capabilityRequests
  }
});

const setCreatedBySystemFilter = (createdBySystem) => ({
  type: types.SET_CREATED_BY_SYSTEM_FILTER,
  payload: {
    createdBySystem
  }
});

const setCertifiedFilter = (certified) => ({
  type: types.SET_CERTIFIED_FILTER,
  payload: {
    certified
  }
});

const setGaccFilter = (gacc) => ({
  type: types.SET_GACC_FILTER,
  payload: {
    gacc
  }
});

const setResponseAgenciesFilter = (responseAgencies) => ({
  type: types.SET_RESPONSE_AGENCIES_FILTER,
  payload: {
    responseAgencies
  }
});

const setStateFilter = (state) => ({
  type: types.SET_STATE_FILTER,
  payload: {
    state
  }
});

const setCountyFilter = (county) => ({
  type: types.SET_COUNTY_FILTER,
  payload: {
    county
  }
});

const setReportSearchTerms = (reportSearchTerms) => ({
  type: types.SET_REPORT_SEARCH_TERMS,
  payload: {
    reportSearchTerms
  }
});

const setPOOIncidentJurisdictionalAgency = (incidentJurisdictionalAgency) => ({
  type: types.SET_INCIDENT_JURISDICTIONAL_AGENCY,
  payload: {
    incidentJurisdictionalAgency
  }
});

const setDispatchCenterID = (dispatchCenterID) => ({
  type: types.SET_DISPATCH_CENTER_ID,
  payload: {
    dispatchCenterID
  }
});

const setPOOProtectingUnit = (pooProtectingUnit) => ({
  type: types.SET_POO_PROTECTING_UNIT,
  payload: {
    pooProtectingUnit
  }
});

const setPOOProtectingAgency = (pooProtectingAgency ) => ({
  type: types.SET_POO_PROTECTING_AGENCY,
  payload: {
    pooProtectingAgency
  }
});

const setPOOJurisdictionalUnit = (jurisdictionalUnit) => ({
  type: types.SET_JURISDICTIONAL_UNIT,
  payload: {
    jurisdictionalUnit
  }
});

/*const setPOOJurisdictionalUnitParentUnit = (jurisdictionalUnitParentUnit) => ({
  type: types.SET_JURISDICTIONAL_UNIT_PARENT_UNIT,
  payload: {
    jurisdictionalUnitParentUnit
  }
});*/

const addUniqueFireIdentifier = (uniqueFireIdentifier) => ({
  type: types.ADD_UNIQUE_FIRE_ID,
  payload: {
    uniqueFireIdentifier
  }
});

const removeUniqueFireIdentifier = (uniqueFireIdentifier) => ({
  type: types.REMOVE_UNIQUE_FIRE_ID,
  payload: {
    uniqueFireIdentifier
  }
});

const clearUniqueFireIdentifiers = () => ({
  type: types.CLEAR_UNIQUE_FIRE_ID,
  payload: {}
});

/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
  manualRehydrateFilter,
  setActiveDrawTool,
  setFilterGeometry,
  setUseExtentFilter,
  setFilterLoading,
  setFilterVisible,
  addFireCause,
  removeFireCause,
  clearFireCause,
  addInitialStrategy,
  removeInitialStrategy,
  clearInitialStrategy,
  addInitialType,
  removeInitialType,
  clearInitialType,
  addLandownerCategory,
  removeLandownerCategory,
  clearLandownerCategory,
  setFireAcreage,
  clearFireAcreage,
  setFireDiscoveryDates,
  clearFireDiscoveryDates,
  setFireOutDates,
  clearFireOutDates,
  setModifiedDates,
  clearModifiedDates,
  setImsrDates,
  clearImsrDates,
  setStructuresFilter,
  setInjuriesFilter,
  setUniquenessFilter,
  setFatalitiesFilter,
  setOtherStructuresDestroyedFilter,
  setResidencesThreatenedFilter,
  setOtherStructuresThreatenedFilter,
  setCertifiedFilter,
  setGaccFilter,
  setResponseAgenciesFilter,
  setStateFilter,
  setCountyFilter,
  setModifiedBySystemFilter,
  setCapabilityRequestsFilter,
  setCreatedBySystemFilter,
  setReportSearchTerms,
  setPOOIncidentJurisdictionalAgency,
  setDispatchCenterID,
  setPOOProtectingUnit,
  setPOOProtectingAgency,
  setPOOJurisdictionalUnit,
  addUniqueFireIdentifier,
  removeUniqueFireIdentifier,
  setBasicFilterActive,
  clearUniqueFireIdentifiers,
  resetFilters,
  setPerimeterMapMethod,
  setPerimeterFeatureAccess,
  setPerimeterFeatureStatus,
  setNarrativeFilter,
  addDataSource,
  removeDataSource,
  clearDataSources,
  setMultiRoot,
  setInImsr,
  setUtcOffsetFilter,
  clearUtcOffsetFilter,
  clearPerimeterAcreage,
  setPerimeterAcreageLandowner,
  setPerimeterAcreageOperator,
  setPerimeterAcreageNumber,
  setHasSpatialFilter,
  setSpatialFilterID,
  clearIrwinRelationships,
  addIrwinRelationship,
  removeIrwinRelationship,
  setMapDrawingPaused
};
